import React, { useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import GoBack from "../../../component/molecules/goBack";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import MainInput from "../../../component/atoms/input/mainInput";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/error-handler";
import { nullCheck } from "../../../util/check";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import TextArea from "../../../component/atoms/input/textarea";
import TermsApi from "../../../api/termsApi";

function TermsAdd(props) {
  const navigate = useNavigate();

  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [data, setData] = useState({
    title: "",
    content: "",
  });

  const saveFunc = async () => {
    try {
      const requestDto = {
        title: data.title,
        content: data.content,
      };

      await TermsApi.Add(requestDto);
      setSaveModalOpen(false);
      navigate(-1);
      toast(toastMsg.create);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage style={{ minHeight: "375px" }}>
            <DetailPageTitle>추가하기</DetailPageTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                marginBottom: "79px",
              }}
            >
              <DetailPageForm>
                <DetailFormTitle>약관명*</DetailFormTitle>
                <MainInput
                  type={"text"}
                  placeholder={"약관명을 입력해주세요"}
                  onChange={(e) => setData({ ...data, title: e.target.value })}
                />
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>약관내용*</DetailFormTitle>
                <TextArea
                  placeholder={"약관내용을 입력해주세요"}
                  onChange={(e) => setData({ ...data, content: e.target.value })}
                />
              </DetailPageForm>
            </div>
            <SaveBtn
              style={{ bottom: "40px", right: "40px" }}
              onClick={() => {
                if (nullCheck(data.title) || nullCheck(data.content)) {
                  setSaveModalOpen(false);
                  return toast("모든 내용을 입력해주세요.");
                }
                setSaveModalOpen(true);
              }}
            />
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
      {saveModalOpen ? (
        <Modal title={modalMsg.create?.title} setModalOpen={setSaveModalOpen} onClick={saveFunc} />
      ) : (
        ""
      )}
    </>
  );
}

export default TermsAdd;
